import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

const normalizePath = (value = '/') => {
    const normalized = `/${String(value || '').replace(/^\/+|\/+$/g, '')}`;
    return normalized === '/' ? '/' : normalized;
};

const isPathActive = (basePath, currentPathname) => {
    const base = normalizePath(basePath);
    const current = normalizePath(currentPathname);

    if (!base || base === '/') {
        return current === '/';
    }

    return current === base || current.startsWith(`${base}/`);
};

export const SidebarMenuOptionItem = ({option}) => {
    const navigate = useNavigate();
    const location = useLocation();
    const pathname = location?.pathname || '/';
    const isActive = isPathActive(option?.link, pathname);

    const handleNavigate = () => {
        navigate(option.link);
    };

    return (
        <li className={`nxl-item hover__link ${isActive ? 'active' : ''}`}>
            <button type="button" className="nxl-link border-0 text-start sidebar-menu-link-btn" onClick={handleNavigate}>
                {option.label}
            </button>
        </li>
    );
};
